var map = {
	"./4ae27c8b-ddaa-4a9a-9447-1fe2e2010ea7.JPG": 369,
	"./59ae2da7-028b-494b-8ac1-154f915ff28b.JPG": 9875,
	"./756beb8a-49b5-4669-8dbd-35c07624359a.JPG": 898,
	"./Cópia de IMG-20220714-WA0029.jpg": 9752,
	"./Cópia de IMG-20230523-WA0041.jpg": 717,
	"./Cópia de IMG_0898.jpg": 3093,
	"./IMG-20230428-WA0014_Original.jpg": 4869,
	"./IMG-20230819-WA0089.jpg": 7296,
	"./IMG_2060.jpg": 4449,
	"./IMG_2095.jpg": 55,
	"./IMG_2110.jpg": 3383,
	"./WhatsApp Image 2025-10-02 at 15.14.19.jpg": 1365,
	"./WhatsApp Image 2025-10-02 at 15.19.46.jpg": 8262,
	"./WhatsApp Image 2025-10-02 at 15.22.22.jpg": 5506,
	"./WhatsApp Image 2025-10-02 at 15.40.14.jpeg": 987,
	"./WhatsApp Image 2026-04-24 at 14.09.05 (2).jpeg": 2987,
	"./WhatsApp Image 2026-04-24 at 14.09.05.jpeg": 4854,
	"./b1c68e4c-b20d-468e-84d9-b571af549604.JPG": 6232,
	"./capa.jpg": 9679,
	"./cce0d47c-afb8-4ab3-8a72-ec34998eb6ff.JPG": 4970
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8001;